import { MapTo } from "@adobe/aem-react-editable-components";
import { ImageInfoBanner } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const imageInfoBannerEditConfig = {
    emptyLabel: "ImageInfoBanner",
    isEmpty: (props) => !props.title || !props.bottomText || !props.backgroundImageSrc,
    getProps: (props) => ({
        title: props.title,
        text: props.text,
        bottomText: props.bottomText,
        url: props.url,
        backgroundImageSrc: props.backgroundImageSrc,
        backgroundImageSrcMedium: props.backgroundImageSrcMedium,
        backgroundImageSrcBig: props.backgroundImageSrcBig,
        color: props.color,
        topRightText: props.topRightText,
        buttonVariant: props.buttonVariant,
        variant: props.variant,
        hasGradient: props.hasGradient,
        isAnimated: props.isAnimated,
    }),
};
export default MapTo("loyalty/components/imageinfobanner")(withAemAuthoring(ImageInfoBanner, imageInfoBannerEditConfig));
